import type { CoachingGoalCondition } from "@repo/app-types/entities/filterConditions";
import { getCoachingGoalPillForFilterStatus } from "@repo/app-types/helpers/coachingGoalProgress";
import type { FC } from "react";
import { RemoveFilterChip } from "./filterChip.js";

export interface CoachingGoalFilterItemProps {
  value: CoachingGoalCondition | null;
  onChange: (newValue: CoachingGoalCondition | null) => void;
}

export const CoachingGoalFilterItem: FC<CoachingGoalFilterItemProps> = (
  props,
) => {
  if (props.value === null) {
    return null;
  }

  return (
    <RemoveFilterChip onRemove={() => props.onChange(null)}>
      {getCoachingGoalPillForFilterStatus(props.value.status).label}
    </RemoveFilterChip>
  );
};
